import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormInput } from '../../../components/Forms/FormInput';
import { SmartContainer, Stack } from '../../../styles/Containers';
import { StyledButton } from '../../../styles/matieralui/Button';
import { createView } from './redux/views.actions';
export const ViewCreatorForm = ({ filters }) => {


    const dispatch = useDispatch();

    const [name, setName] = useState('');
    const [formattedFilters, setFormattedFilters] = useState(null);

    // Validate
    let disableSubmit = !name;

    useEffect(() => {
        const f = {}

        const x = Object.keys(filters).map(key => {
            if (key !== 'appendResults' && filters[key] && filters[key].length > 0) {
                if (key.indexOf('Compare') > 0) {
                    f[key] = filters[key];
                } else {
                    f[key] = JSON.parse((filters[key]));
                }
            }
            return key
        })

        setFormattedFilters(f)
    }, [filters])


    const handleSubmit = (publishing) => {

        // Payload
        const payload = {
            name,
            meta: {
                filters: formattedFilters
            }
        }
        dispatch(createView(payload));
    }

    const keyPress = (e) => {
        if (disableSubmit) return;
        // On Enter
        if (e.keyCode == 13) handleSubmit();
    }

    return (
        <Stack>
            <FormInput onKeyDown={keyPress} label="View Name" type="text" onChange={setName} value={name} />
            <SmartContainer flex align="center" justify="flex-end">
                <StyledButton onClick={handleSubmit} variant="contained" color="primary" disabled={disableSubmit}>Create View</StyledButton>
            </SmartContainer>
        </Stack>
    )
}